/**
 * i18n: location district setup CTA + free-text address search.
 * Tuples are [ko, en, vi, ru].
 */

function pick(obj, langIndex) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  }
  return out;
}

const location = {
  setupDistrictHint: [
    '구·동을 설정해주세요',
    'Set your district',
    'Chọn quận/phường',
    'Укажите район',
  ],
  setupDistrictBadge: ['설정 필요', 'Set up', 'Cần đặt', 'Настроить'],
  addressSearchTab: ['주소로 검색', 'Search by address', 'Tìm theo địa chỉ', 'По адресу'],
  districtSearchTab: ['구·동 검색', 'Search district', 'Tìm quận/phường', 'По району'],
  addressSearchPlaceholder: [
    '도로명·건물명 등 주소 입력',
    'Enter a street or place name',
    'Nhập địa chỉ hoặc tên nơi',
    'Введите адрес или место',
  ],
  addressSearchBtn: ['검색', 'Search', 'Tìm', 'Найти'],
  addressNotFound: [
    '주소를 찾지 못했어요. 다른 표현으로 시도해 주세요.',
    'Address not found. Try a different wording.',
    'Không tìm thấy địa chỉ. Thử cách khác.',
    'Адрес не найден. Попробуйте иначе.',
  ],
  addressOutOfArea: [
    '서비스 지역 밖이거나 가까운 구·동을 찾지 못했어요.',
    'Outside the service area, or no nearby district found.',
    'Ngoài khu vực phục vụ hoặc không tìm thấy quận gần.',
    'Вне зоны сервиса или район не найден.',
  ],
  addressSearching: ['주소 검색 중…', 'Searching address…', 'Đang tìm địa chỉ…', 'Поиск адреса…'],
  areaSettingsTitle: ['주소 설정', 'Set address', 'Đặt địa chỉ', 'Адрес'],
  savedAreasTitle: ['저장된 지역', 'Saved areas', 'Khu vực đã lưu', 'Сохранённые районы'],
  savedAreasEmpty: [
    '아직 저장된 지역이 없어요',
    'No saved areas yet',
    'Chưa có khu vực đã lưu',
    'Пока нет сохранённых районов',
  ],
  savedAreasLoginHint: [
    '로그인하면 자주 가는 지역을 저장해둘 수 있어요',
    'Sign in to save areas you visit often',
    'Đăng nhập để lưu khu vực thường đến',
    'Войдите, чтобы сохранять частые районы',
  ],
  addHomeArea: ['우리집 추가', 'Add home', 'Thêm nhà', 'Добавить дом'],
  homeLabel: ['집', 'Home', 'Nhà', 'Дом'],
  currentAreaBadge: ['현재 설정된 지역', 'Current area', 'Khu vực hiện tại', 'Текущий район'],
  areaLabelField: ['저장 이름', 'Label', 'Nhãn', 'Название'],
  areaLabelPlaceholder: ['예: 집, 회사', 'e.g. Home, Work', 'VD: Nhà, Công ty', 'напр. Дом, Работа'],
  areaLabelEdit: ['이름 수정', 'Edit label', 'Sửa nhãn', 'Изменить название'],
  areaLabelEditPrompt: [
    '저장할 이름을 입력하세요',
    'Enter a label for this area',
    'Nhập tên cho khu vực',
    'Введите название района',
  ],
  areaDeleted: ['지역을 삭제했어요', 'Area deleted', 'Đã xoá khu vực', 'Район удалён'],
  areaSearchHeadline: [
    '지역을 검색해주세요',
    'Search for your area',
    'Tìm khu vực của bạn',
    'Найдите свой район',
  ],
  useCurrentLocationBtn: [
    '현재 위치로 찾기',
    'Use current location',
    'Dùng vị trí hiện tại',
    'Использовать текущее место',
  ],
  addressSearchTipsTitle: [
    '이렇게 검색해 보세요',
    'Try searching like this',
    'Hãy thử tìm kiếm như thế này',
    'Попробуйте так',
  ],
  addressSearchTip1: [
    '도로명 + 건물번호 (예: Bạch Đằng 76)',
    'Street name + building number (e.g. Bach Dang 76)',
    'Tên đường + số nhà (vd: Bạch Đằng 76)',
    'Улица + номер дома',
  ],
  addressSearchTip2: [
    '건물명 + 지역 (예: Vincom Plaza, 하이쩌우)',
    'Building name + area (e.g. Vincom Plaza, Hai Chau)',
    'Tên tòa nhà + khu vực (vd: Vincom Plaza, Hải Châu)',
    'Название здания + район',
  ],
  addressSearchTip3: [
    '아파트명 (예: 무엉타인 럭셔리)',
    'Apartment/complex name (e.g. Muong Thanh Luxury)',
    'Tên chung cư (vd: Mường Thanh Luxury)',
    'Название ЖК',
  ],
  manageAreas: ['관리', 'Manage', 'Quản lý', 'Управление'],
};

function buildLang(langIndex) {
  return { location: pick(location, langIndex) };
}

export const phaseLocationSetupKo = buildLang(0);
export const phaseLocationSetupEn = buildLang(1);
export const phaseLocationSetupVi = buildLang(2);
export const phaseLocationSetupRu = buildLang(3);
